import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import LoadingButton, { LOADING_BUTTON_NOT_DONE } from '../fw/LoadingButtonNew.react';
import ConfirmDialog from '../fw/ConfirmDialog.react';
import SaveFlowInvocationAsTestMutation from './SaveFlowInvocationAsTestMutation.react';
import { getPayloadErrorMessage, getRelayFailureMessage } from '../snapshot-testing/mutationPayload.ts';

export class SaveAsTestButton extends React.Component {
    static propTypes = {
        relay: PropTypes.object,
        flowInvocation: PropTypes.object,
        intl: PropTypes.object,
        onError: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            error: null,
        };
    }

    setError = (error) => {
        this.setState({ error });
        if (this.props.onError) {
            this.props.onError(error);
        }
    };

    handleClick = async () => {
        const { intl, relay, flowInvocation } = this.props;

        let testName;
        try {
            // Show dialog to enter test name
            testName = await ConfirmDialog(intl, {
                message: intl.formatMessage({
                    id: 'flowInvocation.saveAsTest.prompt',
                    defaultMessage: 'Enter a name for this test:',
                }),
                confirmInput: true,
                confirm: intl.formatMessage({
                    id: 'flowInvocation.saveAsTest.confirm',
                    defaultMessage: 'Save as Test',
                }),
            });
        } catch (error) {
            return LOADING_BUTTON_NOT_DONE;
        }

        if (!testName) return LOADING_BUTTON_NOT_DONE;

        this.setState({ isLoading: true });
        try {
            const response = await new Promise((resolve, reject) => {
                relay.commitUpdate(
                    new SaveFlowInvocationAsTestMutation({
                        flowInvocationId: flowInvocation.realId || flowInvocation.id,
                        name: testName,
                        bindToFlow: true,
                    }),
                    { onSuccess: resolve, onFailure: reject }
                );
            });
            const payloadError = getPayloadErrorMessage(
                response && response.saveFlowInvocationAsTest,
                intl.formatMessage({
                    id: 'flowInvocation.saveAsTest.error',
                    defaultMessage: 'Failed to save as test',
                })
            );
            if (payloadError) {
                this.setError(payloadError);
                return LOADING_BUTTON_NOT_DONE;
            }
            this.setError(null);
            // Resolving normally lets the button show its done check: the capture succeeded.
            return undefined;
        } catch (error) {
            const message = getRelayFailureMessage(error, intl.formatMessage({
                id: 'flowInvocation.saveAsTest.error',
                defaultMessage: 'Failed to save as test',
            }));
            this.setError(message);
            return LOADING_BUTTON_NOT_DONE;
        } finally {
            this.setState({ isLoading: false });
        }
    };

    render() {
        return (
            <span className="SaveAsTestButton">
                {!this.props.onError && this.state.error && (
                    <span className="alert alert-danger" role="alert" style={{ display: 'block', marginBottom: 8, whiteSpace: 'normal' }}>
                        {this.state.error}
                    </span>
                )}
                <LoadingButton
                type="button"
                className="btn btn-default"
                onClick={this.handleClick}
                isLoading={this.state.isLoading}
                icon="fa-save"
                text={
                    <FormattedMessage
                        id="flowInvocation.saveAsTest"
                        defaultMessage="Save as Test"
                    />
                }
                />
            </span>
        );
    }
}

export default injectIntl(SaveAsTestButton);
